import { parseISO } from 'date-fns';

/**
 * Parse a bare "YYYY-MM-DD" date string from the backend without UTC-midnight
 * shifting. `new Date("YYYY-MM-DD")` parses per ECMA-262 as UTC midnight, so
 * formatting it back out with the browser's local getters can roll the
 * displayed day back by one for any visitor west of UTC. `parseISO` treats
 * a date-only string as local midnight instead, matching what the backend
 * actually means by the value.
 */
export function parseServerDate(dateOnly: string): Date {
    return parseISO(dateOnly);
}

/**
 * Parse a naive "YYYY-MM-DD HH:mm:ss" datetime string from the backend
 * (server-timezone wall-clock time, no offset marker) as literal date/time
 * components. `new Date("YYYY-MM-DD HH:mm:ss")` (space-separated, non-ISO)
 * has inconsistent cross-browser parsing behavior; converting to an
 * ISO-shaped string first and using `parseISO` reads the same numbers back
 * out consistently everywhere, with no timezone conversion applied.
 */
export function parseServerDateTime(dateTime: string): Date {
    return parseISO(dateTime.replace(' ', 'T'));
}
